import { render, staticRenderFns } from "./r-smart-offer-skin-panel.vue?vue&type=template&id=46b16dfe"
import script from "./r-smart-offer-skin-panel.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-skin-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46b16dfe')) {
      api.createRecord('46b16dfe', component.options)
    } else {
      api.reload('46b16dfe', component.options)
    }
    module.hot.accept("./r-smart-offer-skin-panel.vue?vue&type=template&id=46b16dfe", function () {
      api.rerender('46b16dfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/reskin/r-smart-offer-skin-panel.vue"
export default component.exports